






import { Component, Vue } from "vue-property-decorator";
import AuditEtikaBatukList from "@/components/ppi/audit-etika-batuk/AuditEtikaBatukList.vue";

@Component({
  components: { AuditEtikaBatukList }
})
export default class AuditEtikaBatukPage extends Vue {}
